import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useModal } from "../contexts/ModalContext";
import FormularioRD from "../rdstation/formularioRD";

function OtimizeSeuNegocio({ 
    text = "Otimize seu negócio!", 
    buttonText = "Contratar", 
    onClick,
    className = "",
    type = "gradient", // "gradient" or "solid"
    useFormularioRD = false
}) {
    const { openModal } = useModal();
    
    const handleClick = () => {
        if (useFormularioRD) {
            openModal(<FormularioRD />);
        } else if (onClick) {
            onClick();
        }
    };

    // Determine styles based on type
    const containerStyles = {
        gradient: {
            wrapper: "w-full",
            outerDiv: "relative rounded-[18px] p-[2px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full",
            innerDiv: "bg-[#2b283d] rounded-[16px] py-4 md:py-2 pl-6 pr-4 gap-8 flex items-center w-full justify-between md:justify-start",
            button: "font-poppins-light bg-white text-black flex items-center gap-2.5 rounded-full py-2 md:py-1 px-6 md:px-8 text-[11px] md:text-sm w-fit cursor-pointer hover:scale-105 transition-transform duration-200",
            buttonIcon: "w-4 md:w-6 h-4 md:h-6"
        },
        solid: {
            wrapper: "w-full",
            outerDiv: "bg-[#2A0D5D] rounded-[16px] py-4 px-6 md:px-8 gap-6 flex flex-row items-center justify-between w-full mx-auto",
            innerDiv: "",
            button: "cursor-pointer font-inter-light bg-gradient-to-r from-[#A002CB] to-[#4B3BDB] flex items-center gap-2.5 rounded-full py-2 md:py-1 px-6 md:px-8 text-sm w-fit hover:scale-105 transition-transform duration-200 text-white",
            buttonIcon: "w-4 md:w-6 h-4 md:h-6"
        },
        solidOrange: {
            wrapper: "w-full",
            outerDiv: "bg-[#2A0D5D] rounded-[16px] py-4 px-6 md:px-8 gap-6 flex flex-row items-center justify-between w-full mx-auto",
            innerDiv: "",
            button: "cursor-pointer font-inter-light bg-gradient-to-r from-[#FC0021] to-[#FC0021] flex items-center gap-2.5 rounded-full py-2 md:py-1 px-6 md:px-8 text-sm w-fit hover:scale-105 transition-transform duration-200 text-white",
            buttonIcon: "w-4 md:w-6 h-4 md:h-6"
        }
    };

    const styles = containerStyles[type] || containerStyles.gradient;

    return (
        <div className={`${styles.wrapper} ${className}`}>
            {type === "gradient" ? (
                <div className={styles.outerDiv}>
                    <div className={styles.innerDiv}>
                        <p className="text-[13px] md:text-lg font-inter-light text-white">
                            {text.includes(" ") ? (
                                <>
                                {text.split(" ").slice(0, 2).join(" ")}{" "}
                                <br className="hidden md:block" /> {text.split(" ").slice(2).join(" ")}
                                </>
                            ) : (
                                text
                            )}
                        </p>
                        <button
                            onClick={handleClick}
                            className={styles.button}
                        >
                            {buttonText}
                            <ArrowUpRight className={styles.buttonIcon} />
                        </button>
                    </div>
                </div>
            ) : (
                <div className={styles.outerDiv}>
                    <p className="text-[13px] md:text-lg font-inter-light text-left text-white">
                        {text.includes(" ") ? (
                            <>
                                {text.split(" ").slice(0, 2).join(" ")}{" "}
                                <br className="hidden md:block" /> {text.split(" ").slice(2).join(" ")}
                            </>
                        ) : (
                            text
                        )}
                    </p>
                    <button
                        type="button"
                        onClick={handleClick}
                        className={styles.button}
                    >
                        {buttonText}
                        <ArrowUpRight className={styles.buttonIcon} />
                    </button>
                </div>
            )}
        </div>
    );
}

export default OtimizeSeuNegocio;
